import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initMetaPixelConsentListener, trackPixelPageView } from '../utils/metaPixel';

/**
 * Loads the Meta Pixel once the user has consented to analytics cookies
 * (or immediately, if they already have), and fires a PageView on every
 * route change — including /register/employer, which previously lost
 * conversion tracking when visitors landed here from myhometown.health.
 *
 * Mount once inside the <BrowserRouter>, alongside ScrollToTop.
 */
const MetaPixelTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    initMetaPixelConsentListener();
  }, []);

  useEffect(() => {
    trackPixelPageView();
  }, [pathname]);

  return null;
};

export default MetaPixelTracker;
